import { action } from 'typesafe-actions'

import {
  Id,
  Request,
  RequestItinerary,
  RequestStandardAssignments,
  RequestTicket,
  RequestUserDataStatus,
  SaveRequestStandardAssignments
} from 'src/types'

import {
  RequestsActionTypes,
  ResponseDataFullRequest,
  ResponseDataRequests,
  ResponseDataRequestTotals,
  OriginRequest
} from './types'

interface Options {
  filterStatus?: string[]
  page?: number
  reload?: boolean
  request_numbers?: string
}

export const getFullRequest = (
  request_id: Id,
  origin?: OriginRequest,
  reload = false
) =>
  action(RequestsActionTypes.GET_FULL_REQUEST, {
    origin,
    reload,
    request_id
  })

export const getFullRequestSuccess = ({
  full_request
}: ResponseDataFullRequest) =>
  action(RequestsActionTypes.GET_FULL_REQUEST_SUCCESS, {
    fullRequest: full_request
  })

export const getFullRequestFailure = (message: string) =>
  action(RequestsActionTypes.GET_FULL_REQUEST_FAILURE, { message })

export const getMyRequests = (
  options: Options = {
    filterStatus: [],
    page: 1,
    reload: false,
    request_numbers: ''
  }
) => action(RequestsActionTypes.GET_MY_REQUESTS, { options })

export const getMyRequestsSuccess = ({
  requests: myRequests,
  request_totals,
  total_results
}: ResponseDataRequests) =>
  action(RequestsActionTypes.GET_MY_REQUESTS_SUCCESS, {
    myRequests,
    request_totals,
    totalResults: total_results
  })

export const getMyRequestsFailure = (message: string) =>
  action(RequestsActionTypes.GET_MY_REQUESTS_FAILURE, { message })

export const saveFullRequest = (request: Request, setFullRequest = false) =>
  action(RequestsActionTypes.SAVE_FULL_REQUEST, { request, setFullRequest })

export const saveFullRequestSuccess = (message: string) =>
  action(RequestsActionTypes.SAVE_FULL_REQUEST_SUCCESS, { message })

export const saveFullRequestFailure = (message?: string) =>
  action(RequestsActionTypes.SAVE_FULL_REQUEST_FAILURE, { message })

/** Tickets */
export const saveRequestTickets = (tickets: RequestTicket[]) =>
  action(RequestsActionTypes.SAVE_REQUEST_TICKETS, { tickets })

export const saveRequestTicketsSuccess = (request_tickets: RequestTicket[]) =>
  action(RequestsActionTypes.SAVE_REQUEST_TICKETS_SUCCESS, { request_tickets })

export const saveRequestTicketsFailure = (message: string) =>
  action(RequestsActionTypes.SAVE_REQUEST_TICKETS_FAILURE, { message })

/** Itinerary */
export const saveRequestItinerary = (itinerary: RequestItinerary) =>
  action(RequestsActionTypes.SAVE_REQUEST_ITINERARY, { itinerary })

export const saveRequestItinerarySuccess = (itineraries: RequestItinerary[]) =>
  action(RequestsActionTypes.SAVE_REQUEST_ITINERARY_SUCCESS, { itineraries })

export const saveRequestItineraryFailure = (message: string) =>
  action(RequestsActionTypes.SAVE_REQUEST_ITINERARY_FAILURE, { message })

/** StandardAssignments */
export const saveRequestStandardAssignments = ({
  request_standard_billings,
  request_standard_sharings
}: SaveRequestStandardAssignments) =>
  action(RequestsActionTypes.SAVE_REQUEST_STANDARD_ASSIGNMENTS, {
    request_standard_billings,
    request_standard_sharings
  })

export const saveRequestStandardAssignmentsFailure = (message: string) =>
  action(RequestsActionTypes.SAVE_REQUEST_STANDARD_ASSIGNMENTS_FAILURE, {
    message
  })

export const saveRequestStandardAssignmentsSuccess = (
  request_standard_assignments: RequestStandardAssignments
) =>
  action(RequestsActionTypes.SAVE_REQUEST_STANDARD_ASSIGNMENTS_SUCCESS, {
    request_standard_assignments
  })

export const resetSaveFullRequest = () =>
  action(RequestsActionTypes.RESET_SAVE_FULL_REQUEST)

export const setDraft = (draft: Request) =>
  action(RequestsActionTypes.SET_DRAFT, { draft })

export const setFullRequest = (request: Request) =>
  action(RequestsActionTypes.SET_FULL_REQUEST, { request })

export const setReceiptConferenceCheck = (ticket_id: Id, checked: boolean) =>
  action(RequestsActionTypes.SET_RECEIPT_CONFERENCE_CHECK, {
    checked,
    ticket_id
  })

export const setRequestTotals = (totals: ResponseDataRequestTotals) =>
  action(RequestsActionTypes.SET_REQUEST_TOTALS, {
    request_totals: totals.request_totals
  })

export const setUnderwayStatus = ({
  request_id,
  status
}: {
  request_id: Id
  status: RequestUserDataStatus
}) => action(RequestsActionTypes.SET_UNDERWAY_STATUS, { request_id, status })

export const setUnderwayStatusFailure = (message: string) =>
  action(RequestsActionTypes.SET_UNDERWAY_STATUS_FAILURE, { message })

export const setUnderwayStatusSuccess = () =>
  action(RequestsActionTypes.SET_UNDERWAY_STATUS_SUCCESS)
